import { request } from "@/composables/useFetch";

const prefix = "/v1/admin";
export function list(page, size, keySearch) {
    return request(`${prefix}/staffs?page=${page}&size=${size}&keySearch=${keySearch}`);
}

export function listNotPaging() {
    return request(`${prefix}/staffs/all`);
}

export function create(data) {
    return request(`${prefix}/staff`, {method: 'POST', body: data});
}

export function update(id, data) {
    return request(`${prefix}/staff/${id}`, {method: 'PUT', body: data});
}

export function deleteStaff(id) {
    return request(`${prefix}/staff/${id}`, {method: 'DELETE'});
}
